import React from "react";
import { TextField } from "react-admin";

const NameBgField = ({ sortable = false }) => {
  return (
    <TextField
      source="nameBg"
      sortable={sortable}
    />
  );
};

export default NameBgField;
